import React from 'react';
import '../../assets/styles/Footer.css'

const Footer = () => {
  return (
    <footer className="footer bg-light text-center">
      <div className="container">
        <div className="d-flex justify-content-center flex-column flex-md-row">
          <p className="mb-0 me-0">© {new Date().getFullYear()} Magunex. All rights reserved.</p>
          <p className="mb-0 me-0">
            <a href="/privacy-policy" className="text-decoration-none">Privacy Policy</a>
          </p>
          <p className="mb-0 me-0">|</p>
          <p className="mb-0 me-0">
            <a href="/terms-of-service" className="text-decoration-none">Terms of Service</a>
          </p>
          <p className="mb-0">Contact us: <a href="mailto:support@magunex.com">support@magunex.com</a></p> <p className="mb-0 me-3">Version 1.0</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
